import { useEffect, useState } from "react";
import { useNetwork } from "../context/NetworkContext";

const getTerminal = () => localStorage.getItem("terminal");

export const TerminalBadge = () => {
  // const navigate = useNavigate();
  const { isOnline } = useNetwork();

  const [terminal, setTerminal] = useState<string | null>(getTerminal());

  // 🔄 keep badge updated if terminal changes
  useEffect(() => {
    const syncTerminal = () => setTerminal(getTerminal());
    window.addEventListener("storage", syncTerminal);
    return () => window.removeEventListener("storage", syncTerminal);
  }, []);

  // ❌ don’t show if not logged in
  if (!localStorage.getItem("authToken")) return null;

  const statusColor = !terminal
    ? "bg-red-500"
    : isOnline
      ? "bg-green-500"
      : "bg-yellow-500";

  return (
    <div
      onClick={() => {
        if (terminal === "t1")
          localStorage.setItem("terminal", "t2");
        else localStorage.setItem("terminal", "t1");
        window.location.reload();
      }}
      className="fixed bottom-4 right-4 z-50 cursor-pointer
                 bg-white shadow-lg rounded-full px-4 py-2
                 flex items-center gap-2 hover:scale-105 transition"
      title="Click to change terminal"
    >
      <span className={`w-2.5 h-2.5 rounded-full ${statusColor}`} />
      <span className="text-sm font-medium text-gray-700">
        {terminal ? `Terminal: ${terminal.toUpperCase()}` : "No Terminal"}
      </span>
    </div>
  );
};
